<p-treeTable
    [value]="value()"
    [loading]="loading()"
    [tableStyle]="tableStyle()"
    [tableStyleClass]="tableStyleClass()"
    [styleClass]="styleClass()"
    [selectionMode]="selectionMode()"
    [selectionKeys]="selectionKeys()"
    [metaKeySelection]="metaKeySelection()"
    [dataKey]="dataKey()"
    [sortField]="sortField() ?? undefined"
    [sortOrder]="sortOrder()"
    [defaultSortOrder]="defaultSortOrder()"
    [customSort]="customSort()"
    (onNodeExpand)="onRowExpand($event)"
    (onNodeCollapse)="onRowCollapse($event)"
    (selectionChange)="onSelectionChange($event)"
    (selectionKeysChange)="onSelectionKeysChange($event)"
    (onSort)="onSort($event)"
>
    @if (captionTemplate()) {
        <ng-template #caption>
            <div class="fcp-tree-table-caption">
                <ng-container [ngTemplateOutlet]="captionTemplate()"></ng-container>
            </div>
        </ng-template>
    }

    @if (headerTemplate()) {
        <ng-template #header>
            <ng-container [ngTemplateOutlet]="headerTemplate()"></ng-container>
        </ng-template>
    } @else if (columns()) {
        <ng-template #header>
            <tr>
                @for (column of columns(); track column.field; let first = $first) {
                    <th
                        [style]="column.headerStyle"
                        [class]="column.styleClass"
                        [style.width]="column.width"
                        [ttSortableColumn]="column.sortable ? column.field : null"
                    >
                        <div class="fcp-tree-table-header-cell">
                            @if (first && showExpandCollapseAll()) {
                                <span
                                    class="fc-font-icon fcp-tree-table-expand-all-icon"
                                    [class.fc-font-icon-chevron-down]="!_shouldExpand()"
                                    [class.fc-font-icon-chevron-right]="_shouldExpand()"
                                    (click)="onToggleExpandAll($event)"
                                ></span>
                            }
                            {{ column.header }}
                            @if (column.headerSuffix) {
                                <span class="fcp-tree-table-header-suffix">{{ column.headerSuffix }}</span>
                            }
                            @if (column.sortable) {
                                <span
                                    class="fc-font-icon fcp-tree-table-sort-icon"
                                    [class.fc-font-icon-arrow-small-up]="
                                        sortField() === column.field && sortOrder() === FcpTreeTableSortOrder.Ascending
                                    "
                                    [class.fc-font-icon-arrow-small-down]="
                                        sortField() === column.field && sortOrder() === FcpTreeTableSortOrder.Descending
                                    "
                                    [class.fc-font-icon-chevron-up-down]="
                                        sortField() !== column.field || sortOrder() === FcpTreeTableSortOrder.None
                                    "
                                ></span>
                            }
                            @if (column.headerTooltip) {
                                <span
                                    class="fc-font-icon fc-font-icon-circle-info fcp-tree-table-header-tooltip-icon"
                                    [tooltipPosition]="FcpTooltipPosition.Top"
                                    [fcpTooltip]="column.headerTooltip"
                                    (click)="$event.stopPropagation()"
                                ></span>
                            }
                        </div>
                    </th>
                }
            </tr>
        </ng-template>
    }

    @if (bodyTemplate()) {
        <ng-template #body let-rowNode let-rowIndex="rowIndex">
            <ng-container
                [ngTemplateOutlet]="bodyTemplate()"
                [ngTemplateOutletContext]="{ $implicit: rowNode, rowIndex: rowIndex, treeTable: this }"
            ></ng-container>
        </ng-template>
    } @else if (columns()) {
        <ng-template #body let-rowNode>
            <tr
                [ttRow]="rowNode"
                (click)="onRowClick(rowNode)"
                [class]="'fcp-tree-table-body-cell-level-' + (rowNode.level + 1)"
            >
                @for (column of columns(); track column.field) {
                    <td [style]="column.bodyStyle" [class]="column.styleClass" [style.width]="column.width">
                        @if (column.expander) {
                            <p-treeTableToggler [rowNode]="rowNode" />
                            @if (selectionMode() === FcpTreeTableSelectionMode.Checkbox) {
                                <span class="fcp-tree-table-checkbox" (click)="$event.stopPropagation()">
                                    <p-treeTableCheckbox [value]="rowNode" />
                                </span>
                            }
                        }
                        @if (cellTemplate()) {
                            <ng-container
                                [ngTemplateOutlet]="cellTemplate()!"
                                [ngTemplateOutletContext]="{
                                    $implicit: rowNode.node.data?.[column.field],
                                    field: column.field,
                                    rowNode: rowNode
                                }"
                            />
                        } @else {
                            {{ rowNode.node.data?.[column.field] }}
                        }
                    </td>
                }
            </tr>
        </ng-template>
    }

    @if (footerTemplate()) {
        <ng-template #footer>
            <ng-container [ngTemplateOutlet]="footerTemplate()"></ng-container>
        </ng-template>
    }

    @if (emptyTemplate()) {
        <ng-template #emptymessage>
            <ng-container [ngTemplateOutlet]="emptyTemplate()"></ng-container>
        </ng-template>
    }
</p-treeTable>
